module.exports = __webpack_public_path__ + "static/media/canlı.09a96ba9.jpeg";